import dayjs from 'dayjs'

export default {
    methods: {
        isAppointmentInPast(referral) {
            return dayjs().isAfter(dayjs(referral.appointmentDateTime))
        },
    },
}
